import { inject, onBeforeUnmount, watch } from 'vue';

export const ONBOARDING_NAV_KEY = Symbol('onboardingNav');

/**
 * Register sticky-footer actions with OnboardingHome.
 * Pass a getter that returns { primary, secondary?, onBack?, hideBack?, hidePrimary? }.
 */
export function useRegisterOnboardingNav(getConfig, { clearOnUnmount = true } = {}) {
  const nav = inject(ONBOARDING_NAV_KEY, null);

  if (nav) {
    watch(
      getConfig,
      config => {
        // `undefined` means this component is deferring nav to a child.
        if (config === undefined) return;
        nav.registerNav(config || {});
      },
      { immediate: true, deep: true }
    );

    onBeforeUnmount(() => {
      if (clearOnUnmount) nav.clearNav();
    });
  }

  return nav;
}
